// extracted by mini-css-extract-plugin
export default {"container":"QO-z","topReviewHeading":"RO-z","criticalReview":"SO-z","favorableReview":"TO-z","vsSeparator":"UO-z"};